module.exports = __webpack_public_path__ + "media/stylesheets/images/media/media_mobile_belcy-0f2f9a2e0b76788cd422aededc33b743.png";